(function(){
  if(window.__lloScrollReady) return;
  window.__lloScrollReady = true;

  var SVGNS = 'http://www.w3.org/2000/svg';
  var FALLBACK = '.llo__atc, .llo__app, .llo__sticky, .llorrea-product-section, [data-llo]';

  function addChecks(){
    document.querySelectorAll('[class*="__guarantee"] svg').forEach(function(svg){
      if(svg.querySelector('[data-llo-check]')) return;
      var p = document.createElementNS(SVGNS, 'path');
      p.setAttribute('d', 'M4.7 7.7l1.6 1.7 3.2-3.6');
      p.setAttribute('stroke', 'currentColor');
      p.setAttribute('stroke-width', '1.3');
      p.setAttribute('stroke-linecap', 'round');
      p.setAttribute('stroke-linejoin', 'round');
      p.setAttribute('fill', 'none');
      p.setAttribute('data-llo-check', '');
      svg.appendChild(p);
    });
  }

  function findTarget(list){
    var parts = ((list || '') + ',' + FALLBACK).split(',');
    for(var i = 0; i < parts.length; i++){
      var sel = parts[i].trim();
      if(!sel) continue;
      var el;
      try { el = document.querySelector(sel); } catch(err) { el = null; }
      if(el) return el;
    }
    return null;
  }

  // ---- which element actually scrolls -------------------------------------
  // Some themes make a wrapper the scroll container instead of the document.
  // window.scrollTo() then silently does nothing.
  function scroller(){
    var doc = document.scrollingElement || document.documentElement;
    if(doc && doc.scrollHeight - doc.clientHeight > 2) return doc;
    var cands = [
      document.querySelector('.page-wrapper'),
      document.getElementById('MainContent'),
      document.body
    ];
    for(var i = 0; i < cands.length; i++){
      var c = cands[i];
      if(c && c.scrollHeight - c.clientHeight > 2) return c;
    }
    return doc;
  }

  function isDocScroller(sc){
    return sc === document.documentElement || sc === document.body || sc === document.scrollingElement;
  }

  function getTop(sc){
    return isDocScroller(sc) ? (window.pageYOffset || sc.scrollTop || 0) : sc.scrollTop;
  }

  function setTop(sc, top, smooth){
    var smoothOk = smooth && 'scrollBehavior' in document.documentElement.style;
    if(isDocScroller(sc)){
      if(smoothOk) window.scrollTo({ top: top, behavior: 'smooth' });
      else { window.scrollTo(0, top); sc.scrollTop = top; }
    } else {
      if(smoothOk && sc.scrollTo) sc.scrollTo({ top: top, behavior: 'smooth' });
      else sc.scrollTop = top;
    }
  }

  function viewport(sc){
    if(isDocScroller(sc)) return { top: 0, bottom: window.innerHeight };
    var r = sc.getBoundingClientRect();
    return { top: r.top, bottom: r.bottom };
  }

  // ---- geometry ------------------------------------------------------------
  // offsetTop chain = static layout position, unaffected by position:sticky.
  function absTop(el){
    var top = 0, node = el;
    while(node){
      top += node.offsetTop || 0;
      node = node.offsetParent;
    }
    return top;
  }

  function stickyAncestor(el){
    var node = el;
    while(node && node.nodeType === 1 && node !== document.body){
      var cs = null;
      try { cs = window.getComputedStyle(node); } catch(err) { cs = null; }
      if(cs && cs.position === 'sticky') return { el: node, top: parseFloat(cs.top) || 0 };
      node = node.parentElement;
    }
    return null;
  }

  function desiredTop(el, offset, align, sc){
    var vh = isDocScroller(sc) ? window.innerHeight : sc.clientHeight;
    var top = absTop(el);
    var height = el.offsetHeight || 0;
    var want;

    if(align === 'top'){
      want = top - offset;
    } else {
      want = top + height - vh + offset;
      if(want > top - offset) want = top - offset;
    }

    // While a sticky ancestor is pinned the element sits at a fixed distance
    // from the top of the viewport and cannot be moved to the bottom. Cap at
    // the last scroll position where the column still flows normally.
    var sticky = stickyAncestor(el);
    if(sticky){
      var unpinnedMax = absTop(sticky.el) - sticky.top;
      if(want > unpinnedMax) want = unpinnedMax;
    }

    if(want < 0) want = 0;
    var max = (isDocScroller(sc) ? document.documentElement.scrollHeight : sc.scrollHeight) - vh;
    if(max < 0) max = 0;
    if(want > max) want = max;
    return want;
  }

  // Live delta from the painted box, used to correct after the jump.
  function delta(el, offset, align, sc){
    var r = el.getBoundingClientRect();
    var v = viewport(sc);
    if(align === 'top') return r.top - (v.top + offset);
    return r.bottom - (v.bottom - offset);
  }

  function scrollTo(el, offset, align){
    var sc = scroller();
    var before = getTop(sc);
    var want = desiredTop(el, offset, align, sc);

    setTop(sc, want, true);

    // If smooth scrolling was blocked or ignored, force it hard.
    setTimeout(function(){
      if(Math.abs(getTop(sc) - before) < 2 && Math.abs(want - before) > 4){
        setTop(sc, want, false);
      }
    }, 260);

    // Up to two delta corrections. Abort as soon as a step stops moving the
    // page, which is what happens when a sticky column is pinned.
    var step = 0;
    function correct(){
      step++;
      var d = delta(el, offset, align, sc);
      if(Math.abs(d) <= 8 || step > 2) return;
      var at = getTop(sc);
      setTop(sc, at + d, false);
      if(Math.abs(getTop(sc) - at) < 2) return;
      setTimeout(correct, 220);
    }
    setTimeout(correct, 760);
  }

  document.addEventListener('click', function(e){
    var btn = e.target && e.target.closest ? e.target.closest('[data-llo-scroll]') : null;
    if(!btn) return;
    var target = findTarget(btn.getAttribute('data-llo-scroll'));
    if(!target) return;
    e.preventDefault();

    var offset = parseInt(btn.getAttribute('data-llo-offset') || '24', 10);
    if(isNaN(offset)) offset = 24;
    var align = btn.getAttribute('data-llo-align') || 'bottom';

    scrollTo(target, offset, align);
  });

  function boot(){ addChecks(); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
